import type { LayoutRecord } from "~~/server/graphql/datocms/generated";

export async function useLayout() {
  const nuxtApp = useNuxtApp();
  const { locale } = useI18n();

  // locale is a ref, so it will trigger the fetch when it changes
  const { data } = await useFetch<LayoutRecord>("/api/cms/layout", {
    key: () => `layout-record-${locale.value}`,
    query: { locale: locale },
    getCachedData: key => nuxtApp.payload.data[key] || nuxtApp.static.data[key],
  });

  return data;
}
